"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MOMENT_FORMAT_YEAR = exports.MOMENT_FORMAT_TIME_CLIENT = exports.MOMENT_FORMAT_SERVER = exports.MOMENT_FORMAT_MONTH_YEAR_SHORT = exports.MOMENT_FORMAT_MONTH_YEAR_ABBREVIATED = exports.MOMENT_FORMAT_MONTH_YEAR = exports.MOMENT_FORMAT_MONTH_DAY_SHORT = exports.MOMENT_FORMAT_MONTH_DAY_ORDINAL = exports.MOMENT_FORMAT_MONTH_DAY = exports.MOMENT_FORMAT_MONTH_ABBREVIATED_AND_DAY = exports.MOMENT_FORMAT_MONTH_ABBREVIATED = exports.MOMENT_FORMAT_MONTH = exports.MOMENT_FORMAT_DATE_TIME_CLIENT = exports.MOMENT_FORMAT_DATE_SHORT = exports.MOMENT_FORMAT_DATE_SERVER = exports.MOMENT_FORMAT_DATE_CLIENT_SHORT = exports.MOMENT_FORMAT_DATE_CLIENT_PRETTY_LONG = exports.MOMENT_FORMAT_DATE_CLIENT_PRETTY = exports.MOMENT_FORMAT_DATE_CLIENT_NO_SYMBOLS = exports.MOMENT_FORMAT_DATE_CLIENT_DOUBLE = exports.MOMENT_FORMAT_DATE_CLIENT = exports.MOMENT_FORMAT_DATETIME_CLIENT = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _numeral = _interopRequireDefault(require("numeral"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isNull = _interopRequireDefault(require("lodash/isNull"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _reduce = _interopRequireDefault(require("lodash/reduce"));

var _replace = _interopRequireDefault(require("lodash/replace"));

var _trim = _interopRequireDefault(require("lodash/trim"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOMENT_FORMAT_SERVER = "YYYY-MM-DDTHH:mm:ss";
exports.MOMENT_FORMAT_SERVER = MOMENT_FORMAT_SERVER;
var MOMENT_FORMAT_DATE_SERVER = "YYYY-MM-DD";
exports.MOMENT_FORMAT_DATE_SERVER = MOMENT_FORMAT_DATE_SERVER;
var MOMENT_FORMAT_DATETIME_CLIENT = "M/D/YYYY h:mm:ss a";
exports.MOMENT_FORMAT_DATETIME_CLIENT = MOMENT_FORMAT_DATETIME_CLIENT;
var MOMENT_FORMAT_TIME_CLIENT = "h:mm a";
exports.MOMENT_FORMAT_TIME_CLIENT = MOMENT_FORMAT_TIME_CLIENT;
var MOMENT_FORMAT_DATE_CLIENT_NO_SYMBOLS = "MMDDYYYY";
exports.MOMENT_FORMAT_DATE_CLIENT_NO_SYMBOLS = MOMENT_FORMAT_DATE_CLIENT_NO_SYMBOLS;
var MOMENT_FORMAT_DATE_CLIENT = "M/D/YYYY";
exports.MOMENT_FORMAT_DATE_CLIENT = MOMENT_FORMAT_DATE_CLIENT;
var MOMENT_FORMAT_DATE_TIME_CLIENT = "M/D/YYYY h:mm a";
exports.MOMENT_FORMAT_DATE_TIME_CLIENT = MOMENT_FORMAT_DATE_TIME_CLIENT;
var MOMENT_FORMAT_DATE_CLIENT_SHORT = "M/D/YY";
exports.MOMENT_FORMAT_DATE_CLIENT_SHORT = MOMENT_FORMAT_DATE_CLIENT_SHORT;
var MOMENT_FORMAT_DATE_CLIENT_DOUBLE = "MM/DD/YYYY";
exports.MOMENT_FORMAT_DATE_CLIENT_DOUBLE = MOMENT_FORMAT_DATE_CLIENT_DOUBLE;
var MOMENT_FORMAT_DATE_CLIENT_PRETTY = "MMMM D, YYYY";
exports.MOMENT_FORMAT_DATE_CLIENT_PRETTY = MOMENT_FORMAT_DATE_CLIENT_PRETTY;
var MOMENT_FORMAT_DATE_CLIENT_PRETTY_LONG = "MMMM D, YYYY, h:mm a";
exports.MOMENT_FORMAT_DATE_CLIENT_PRETTY_LONG = MOMENT_FORMAT_DATE_CLIENT_PRETTY_LONG;
var MOMENT_FORMAT_DATE_SHORT = "MM/YYYY";
exports.MOMENT_FORMAT_DATE_SHORT = MOMENT_FORMAT_DATE_SHORT;
var MOMENT_FORMAT_MONTH_YEAR = "MMMM YYYY";
exports.MOMENT_FORMAT_MONTH_YEAR = MOMENT_FORMAT_MONTH_YEAR;
var MOMENT_FORMAT_MONTH_DAY = "MMMM D";
exports.MOMENT_FORMAT_MONTH_DAY = MOMENT_FORMAT_MONTH_DAY;
var MOMENT_FORMAT_MONTH_DAY_ORDINAL = "MMMM Do";
exports.MOMENT_FORMAT_MONTH_DAY_ORDINAL = MOMENT_FORMAT_MONTH_DAY_ORDINAL;
var MOMENT_FORMAT_MONTH_DAY_SHORT = "M/D";
exports.MOMENT_FORMAT_MONTH_DAY_SHORT = MOMENT_FORMAT_MONTH_DAY_SHORT;
var MOMENT_FORMAT_MONTH_YEAR_SHORT = "M/YY";
exports.MOMENT_FORMAT_MONTH_YEAR_SHORT = MOMENT_FORMAT_MONTH_YEAR_SHORT;
var MOMENT_FORMAT_MONTH_YEAR_ABBREVIATED = "MMM 'YY";
exports.MOMENT_FORMAT_MONTH_YEAR_ABBREVIATED = MOMENT_FORMAT_MONTH_YEAR_ABBREVIATED;
var MOMENT_FORMAT_MONTH_ABBREVIATED = "MMM YYYY";
exports.MOMENT_FORMAT_MONTH_ABBREVIATED = MOMENT_FORMAT_MONTH_ABBREVIATED;
var MOMENT_FORMAT_MONTH_ABBREVIATED_AND_DAY = "MMM D, YYYY";
exports.MOMENT_FORMAT_MONTH_ABBREVIATED_AND_DAY = MOMENT_FORMAT_MONTH_ABBREVIATED_AND_DAY;
var MOMENT_FORMAT_MONTH = "MMMM";
exports.MOMENT_FORMAT_MONTH = MOMENT_FORMAT_MONTH;
var MOMENT_FORMAT_YEAR = "YYYY";
exports.MOMENT_FORMAT_YEAR = MOMENT_FORMAT_YEAR;
var _default = {
  lastCharacters: function lastCharacters(value, numCharacters) {
    var trimmedValue = (0, _trim.default)(value);
    return trimmedValue.substr(Math.max(0, trimmedValue.length - numCharacters));
  },
  localDateTime: function localDateTime(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_DATETIME_CLIENT);
  },
  localDate: function localDate(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_DATE_CLIENT);
  },
  localDateDouble: function localDateDouble(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_DATE_CLIENT_DOUBLE);
  },
  utcDate: function utcDate(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_DATE_CLIENT);
  },
  localDateWithTime: function localDateWithTime(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_DATE_TIME_CLIENT);
  },
  utcShortDate: function utcShortDate(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_DATE_SHORT);
  },
  utcPrettyDate: function utcPrettyDate(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_DATE_CLIENT_PRETTY);
  },
  utcDateDouble: function utcDateDouble(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_DATE_CLIENT_DOUBLE);
  },
  utcMonthOnly: function utcMonthOnly(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_MONTH);
  },
  utcYearOnly: function utcYearOnly(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_YEAR);
  },
  localTimeWithUtcTitle: function localTimeWithUtcTitle(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER);

    return /*#__PURE__*/_react.default.createElement("span", {
      title: utcDate.format(MOMENT_FORMAT_TIME_CLIENT) + " UTC"
    }, (0, _moment.default)(utcDate.toDate()).format(MOMENT_FORMAT_TIME_CLIENT));
  },
  // Can't use an arrow function because we use "this"
  localDateTimeWithUtcTitle: function localDateTimeWithUtcTitle(dateString) {
    // eslint-disable-line object-shorthand
    return /*#__PURE__*/_react.default.createElement("span", {
      title: _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_DATETIME_CLIENT) + " UTC"
    }, this.localDateTime(dateString));
  },
  localPrettyDate: function localPrettyDate(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_DATE_CLIENT_PRETTY);
  },
  localPrettyDateLong: function localPrettyDateLong(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_DATE_CLIENT_PRETTY_LONG);
  },
  localMonthAndDay: function localMonthAndDay(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_MONTH_DAY);
  },
  localMonthAndDayOrdinal: function localMonthAndDayOrdinal(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_MONTH_DAY_ORDINAL);
  },
  localMonthAndYear: function localMonthAndYear(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_MONTH_YEAR);
  },
  localMonthAbbreviatedAndYear: function localMonthAbbreviatedAndYear(dateString) {
    var utcDate = _moment.default.utc(dateString, MOMENT_FORMAT_SERVER).toDate();

    return (0, _moment.default)(utcDate).format(MOMENT_FORMAT_MONTH_ABBREVIATED);
  },
  utcMonthAndDay: function utcMonthAndDay(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_MONTH_DAY);
  },
  utcMonthAndYear: function utcMonthAndYear(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_MONTH_YEAR);
  },
  utcMonthAndDayShort: function utcMonthAndDayShort(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_MONTH_DAY_SHORT);
  },
  utcMonthAndYearAbbreviated: function utcMonthAndYearAbbreviated(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_MONTH_YEAR_ABBREVIATED);
  },
  utcMonthAbbreviatedAndYear: function utcMonthAbbreviatedAndYear(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_MONTH_ABBREVIATED);
  },
  utcMonthAbbreviatedDayAndYear: function utcMonthAbbreviatedDayAndYear(dateString) {
    return (0, _moment.default)(dateString, MOMENT_FORMAT_SERVER).format(MOMENT_FORMAT_MONTH_ABBREVIATED_AND_DAY);
  },
  phoneNumber: function phoneNumber(phone) {
    if (!(0, _isEmpty.default)(phone)) {
      var strippedValue = (0, _replace.default)(phone, /[^0-9]/g, "");

      if (strippedValue.length === 10) {
        return "(" + strippedValue.substring(0, 3) + ") " + strippedValue.substring(3, 6) + "-" + strippedValue.substring(6);
      }

      if (strippedValue.length === 11) {
        return "+" + strippedValue.substring(0, 1) + "-" + strippedValue.substring(1, 4) + "-" + strippedValue.substring(4, 7) + "-" + strippedValue.substring(7);
      }
    }

    return phone;
  },
  taxId: function taxId(_taxId) {
    if (!(0, _isEmpty.default)(_taxId)) {
      var strippedValue = (0, _replace.default)(_taxId, /[^0-9]/g, "");

      if (strippedValue.length === 9) {
        return strippedValue.substring(0, 3) + "-" + strippedValue.substring(3, 5) + "-" + strippedValue.substring(5);
      }
    }

    return _taxId;
  },
  maskedTaxId: function maskedTaxId(taxId) {
    if (!(0, _isEmpty.default)(taxId)) {
      var strippedValue = (0, _replace.default)(taxId, /[^0-9]/g, "");

      if (strippedValue.length === 9) {
        return "XXX-XX-" + strippedValue.substring(5);
      }
    }

    return taxId;
  },
  money: function money(value) {
    return (0, _numeral.default)(value).format("$0,00.00");
  },
  moneyParenthetical: function moneyParenthetical(value) {
    return (0, _numeral.default)(value).format("($0,00.00)");
  },
  prettyWholeNumber: function prettyWholeNumber(value) {
    return (0, _numeral.default)(value).format("0,0");
  },
  prettyNumberWithTwoDecimalPlaces: function prettyNumberWithTwoDecimalPlaces(value) {
    return (0, _numeral.default)(value).format("0,0.00");
  },
  prettyNumberWithDecimalsIfNecessary: function prettyNumberWithDecimalsIfNecessary(value) {
    return (0, _numeral.default)(value).format("0,00.[00]");
  },
  moneyWhole: function moneyWhole(value) {
    return (0, _numeral.default)(value).format("$0,00");
  },
  moneyWholeFloor: function moneyWholeFloor(value) {
    return (0, _numeral.default)(Math.floor(value)).format("$0,00");
  },
  moneyWithCentsIfNecessary: function moneyWithCentsIfNecessary(value) {
    return (0, _numeral.default)(value).format(value !== Math.floor(value) ? "$0,00.00" : "$0,00");
  },
  percentage: function percentage(value) {
    return (0, _numeral.default)(value).format("0.00%");
  },
  percentageSmall: function percentageSmall(value) {
    if ((0, _isNil.default)(value)) {
      return value;
    } else {
      return (0, _numeral.default)(value * 0.01).format("0.00%");
    }
  },
  nullable: function nullable(valueOrFunction) {
    if (typeof valueOrFunction === "function") {
      // function
      return function (v) {
        return v ? valueOrFunction(v) : "-";
      };
    } else {
      // value
      var useNull = (0, _isNull.default)(valueOrFunction) || (0, _isUndefined.default)(valueOrFunction) || valueOrFunction === "";
      return useNull ? "-" : valueOrFunction;
    }
  },
  tin: function tin(value) {
    if (!(0, _isEmpty.default)(value)) {
      var strippedValue = (0, _replace.default)(value, /[^0-9]/g, "");

      if (strippedValue.length === 9) {
        // 9 numbers and not empty is a tin, format properly
        return strippedValue.substring(0, 2) + "-" + strippedValue.substring(2);
      }
    }

    return value;
  },
  ordinal: function ordinal(number) {
    return (0, _numeral.default)(number).format("0o");
  },
  currencyChartAxis: function currencyChartAxis(value) {
    return (0, _numeral.default)(value).format('$0.0a');
  },
  labelledSpan: function labelledSpan(v) {
    return /*#__PURE__*/_react.default.createElement("label", {
      title: v
    }, v);
  },
  numberAndNoun: function numberAndNoun(count, singularNoun, pluralNoun) {
    return count === 1 ? "".concat(count, " ").concat(singularNoun) : "".concat((0, _numeral.default)(count).format("0,0"), " ").concat(pluralNoun);
  },
  arrayOfStringsToString: function arrayOfStringsToString(arrayOfStrings, lastWord) {
    var reduceFunction = function reduceFunction(result, value, key) {
      if (Number(key) === arrayOfStrings.length - 1) {
        result += value;
        return result;
      }

      if (Number(key) === arrayOfStrings.length - 2) {
        result += "".concat(value, " ").concat(lastWord, " ");
        return result;
      }

      result += "".concat(value, ", ");
      return result;
    };

    return (0, _reduce.default)(arrayOfStrings, reduceFunction, "");
  }
};
exports.default = _default;